import { REMOVE_VOUCHER, SET_VOUCHER, SetVoucherAction } from './actions';
import { Voucher } from '../../../Voucher/types';
import { Action } from 'redux-actions';

const initialState: Voucher = {
	code: '',
	status: null,
	money: null
};

export const vouchersReducer = (state: Voucher = initialState, action: SetVoucherAction | Action<null>): Voucher => {
	switch (action.type) {
		case REMOVE_VOUCHER:
			return initialState;

		case SET_VOUCHER:
			return (action as SetVoucherAction).payload;

		default:
			return state;
	}
};
